var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailClicksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.1555,
    r: 16,
    fill: "#6921C4",
    fillOpacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21739 16.8512H11.4783",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.0686V12.3294",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8351 13.686L11.1771 12.028",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1655 13.686L20.8234 12.028",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8351 20.0164L11.1771 21.6743",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3044 16.1555L23.6522 18.9382L19.942 20.7932L18.087 24.5034L15.3044 16.1555Z",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.087,
    height: 18.087,
    fill: "white",
    transform: "translate(6.95653 7.80771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailClicksIcon);
export default __webpack_public_path__ + "static/media/MailClicksIcon.dea7cabb.svg";
export { ForwardRef as ReactComponent };